module.exports = __webpack_public_path__ + "img/icon_sec6_03.8827e3d7.png";